import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const faqItems = [
  { id: "1", question: "Como funciona a metodologia Advanse IA?", answer: "A Advanse IA e uma metodologia completa que ensina voce a criar imagens de estudio profissionais usando inteligencia artificial. Voce aprendera desde os fundamentos ate tecnicas avancadas de geracao, edicao e pos-producao de imagens com qualidade de estudio." },
  { id: "2", question: "Preciso de equipamento caro para comecar?", answer: "Nao! Um dos grandes diferenciais da Advanse IA e justamente eliminar a necessidade de equipamentos caros. Tudo que voce precisa e um computador com acesso a internet. Nos ensinamos como usar ferramentas de IA para criar resultados que rivalizam com estudios profissionais." },
  { id: "3", question: "Quanto tempo leva para ver resultados?", answer: "Ja nas primeiras aulas voce sera capaz de gerar suas primeiras imagens de alta qualidade. Ao final do modulo 2, voce tera dominio suficiente para criar imagens de nivel profissional consistentemente." },
  { id: "4", question: "Para quem e indicado o curso?", answer: "O curso e ideal para fotografos que querem expandir seu portfolio, profissionais de marketing, criadores de conteudo, designers e qualquer pessoa interessada em criar imagens profissionais com IA." },
  { id: "5", question: "Tenho acesso vitalicio ao conteudo?", answer: "Sim! Ao se inscrever, voce recebe acesso vitalicio a todo o conteudo do curso, incluindo futuras atualizacoes e novos modulos que adicionarmos." },
  { id: "6", question: "Existe suporte durante o curso?", answer: "Sim, oferecemos suporte completo atraves de nossa comunidade exclusiva, alem de sessoes de mentoria em grupo semanais durante os primeiros 3 meses apos a inscricao." },
];

export default function FAQ() {
  const items = faqItems;

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 lg:py-40 bg-[#0A0A0A]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-16 md:mb-20">
          <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[#00FF00] mb-4">
            // Perguntas frequentes
          </p>
          <h2 className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-white">
            Tire suas <span className="text-[#00FF00]">duvidas</span>
          </h2>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="w-full">
          {items.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              data-testid={`faq-accordion-item-${item.id}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${item.id}`}
                className="text-left text-base md:text-lg font-['Manrope'] font-medium text-white hover:text-[#00FF00] transition-colors duration-300 hover:no-underline py-6 [&[data-state=open]]:text-[#00FF00] [&[data-state=open]>svg]:text-[#00FF00]"
              >
                {item.question}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${item.id}`}
                className="text-sm md:text-base text-white/50 leading-relaxed pb-6"
              >
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
